// Retorna la fecha de hoy en formato YYYY-MM-DD usando la hora LOCAL del usuario,
// no UTC. Importante para Argentina (UTC-3): después de las 21hs el UTC ya es mañana.
export function localToday() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

// Límites del día LOCAL de hoy (00:00 a 00:00 de mañana), en ISO, para
// filtrar columnas timestamp (created_at, completada_en) con gte/lt — a
// diferencia de columnas "date" como agenda.fecha, que se filtran directo
// comparando contra localToday().
export function localTodayRange() {
  const inicio = new Date();
  inicio.setHours(0, 0, 0, 0);
  const fin = new Date(inicio);
  fin.setDate(fin.getDate() + 1);
  return { inicio: inicio.toISOString(), fin: fin.toISOString() };
}

// Inicio del día LOCAL de hace N días, en ISO — para traer el rango
// histórico completo con un solo gte.
export function localHaceNDias(n) {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() - (n - 1)); // incluye el día de hoy como día 1
  return d.toISOString();
}

// Convierte un timestamp ISO (de la base) a YYYY-MM-DD en la fecha LOCAL
// del usuario — para agrupar filas de created_at/completada_en por día.
export function isoToLocalDateStr(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
